module.exports = __webpack_public_path__ + "img/service.9dd98aeb.png";